import Store from "App/Store.js";
import ContentQuery from "Content/ContentQuery.js";

export default (props, queryId) => Store.dispatch({
	type: (!queryId ? "contentQuery" : "contentQueries"),
	query: Object.assign(new ContentQuery(), props),
	queryId
});
